import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Shop from "./pages/Shop";
import BookReading from "./pages/BookReading";
import HouseCalls from "./pages/HouseCalls";
import Testimonials from "./pages/Testimonials";
import Knowledge from "./pages/Knowledge";
import Article from "./pages/Article";
import Contact from "./pages/Contact";
import SocialHub from "./pages/SocialHub";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import ReviewRequest from "./pages/ReviewRequest";
import CustomCandleTracker from "./pages/CustomCandleTracker";
import CartPage from "./pages/CartPage";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/CartDrawer";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/book-reading" element={<BookReading />} />
              <Route path="/house-calls" element={<HouseCalls />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/knowledge/:slug" element={<Article />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/social-hub" element={<SocialHub />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/review/:token" element={<ReviewRequest />} />
              <Route path="/my-candle/:intakeId" element={<CustomCandleTracker />} />
              <Route path="/refund-policy" element={<LegalPage />} />
              <Route path="/cancellation-policy" element={<LegalPage />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/disclaimer" element={<LegalPage />} />
            </Route>
          </Routes>
          <CartDrawer />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
